import { QdsSignatureCardProps } from "../QdsSignatures.types";
import { Icon } from "../../../modules/icon";
import { RoleBasedAccess } from "../../../components/guard";
import { UserRoles } from "../../../entities/IUser";
import { useTranslation } from "react-i18next";

export const QdsSignatureCardActions = ({ id, onDelete, onResend, qdsRequest }: QdsSignatureCardProps) => {
  const { t } = useTranslation();

  return (
    <>
      <div
        className="flex-row dismiss-signature shadow"
        onClick={(event) => {
          event?.stopPropagation();
        }}
      >
        <RoleBasedAccess allowedRoles={[UserRoles.ADMIN]}>
          <Icon
            title={t("DOCUMENTS.RESEND_QDS_REQUEST")}
            color={"#666666"}
            type="fa-solid fa-redo"
            onClick={(event) => {
              event?.stopPropagation();
              onResend(id);
            }}
          />
          <Icon
            title={t("DOCUMENTS.DELETE_QDS_REQUEST")}
            color={"#666666"}
            type="fa-solid fa-trash"
            onClick={(event) => {
              event?.stopPropagation();
              onDelete(id);
            }}
          />
        </RoleBasedAccess>
      </div>
      <div className="qds-card-icon-container">
        <Icon type="fa-regular fa-file" size={64} title={qdsRequest?.documentName} />
      </div>
    </>
  );
};
